import { render } from "./RegisterQuestion.vue?vue&type=template&id=d18dc48c"
import script from "./RegisterQuestion.vue?vue&type=script&lang=js"
export * from "./RegisterQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__